/* ============================================================
   AHIMSA — Variant Gallery Override
   ------------------------------------------------------------
   Problem this fixes:
   Dawn's product-info.js updateMedia() reconciles ONLY the main
   slides <ul> (media-gallery ul :first) and never the thumbnail
   <ul>, and it prepends the featured image. With our per-variant
   multi-image gallery (product-media-gallery.liquid), that leaves
   stale thumbnails (e.g. the PBP tile showing on Sardine) and
   scrambles order on variant click.

   A full page refresh renders BOTH <ul>s in the correct Liquid
   order and works perfectly. So this override makes a variant
   CLICK behave like a refresh: it replaces the entire
   <media-gallery> inner HTML (both main slides + thumbnails) with
   the freshly-fetched, correctly-ordered markup, then re-inits.

   Load order: this file must load AFTER product-info.js so the
   ProductInfo class exists on the global scope to patch.
   ============================================================ */
(function () {
  function patch() {
    if (!window.customElements) return false;
    var ProductInfo = customElements.get('product-info');
    if (!ProductInfo || !ProductInfo.prototype) return false;
    if (ProductInfo.prototype.__ahimsaGalleryPatched) return true;

    // Preserve the original in case we ever want to fall back.
    var originalUpdateMedia = ProductInfo.prototype.updateMedia;

    ProductInfo.prototype.updateMedia = function (html, variantFeaturedMediaId) {
      try {
        // The freshly-fetched section HTML already contains our correct
        // per-variant order (proven: a refresh renders it right).
        var newGallery = html.querySelector('media-gallery');
        var currentGallery = this.querySelector('media-gallery');

        if (!newGallery || !currentGallery) {
          // Nothing to swap the Ahimsa way — defer to Dawn's original.
          return originalUpdateMedia.call(this, html, variantFeaturedMediaId);
        }

        // Full-replace the gallery's inner markup (both the main slides
        // <ul> and the thumbnails <ul>) with the correctly-ordered set.
        currentGallery.innerHTML = newGallery.innerHTML;

        // Re-establish the custom-element wiring on the freshly injected
        // markup. media-gallery.js binds thumbnail click handlers and the
        // slideChanged listener in its constructor; because we replaced
        // innerHTML (not the element), we rebind manually here.
        rebindGallery(currentGallery, this);

        // Re-init hover zoom if the theme uses it.
        if (this.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') {
          enableZoomOnHover(2);
        }

        // Make the variant's featured image the active slide WITHOUT
        // prepending (prepend is what scrambled order). We pass false.
        if (variantFeaturedMediaId) {
          currentGallery.setActiveMedia &&
            currentGallery.setActiveMedia(this.dataset.section + '-' + variantFeaturedMediaId, false);
        }

        // Swap the modal (zoom/lightbox) content too, so zoom matches.
        var modalContent = this.productModal && this.productModal.querySelector('.product-media-modal__content');
        var newModalContent = html.querySelector('product-modal .product-media-modal__content');
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      } catch (e) {
        // Absolute safety: if anything above throws, fall back to Dawn's
        // original behaviour so the gallery is never left broken.
        console.warn('[Ahimsa] variant gallery override failed, using Dawn default:', e);
        return originalUpdateMedia.call(this, html, variantFeaturedMediaId);
      }
    };

    // Rebind the handlers that media-gallery.js normally wires in its
    // constructor. We replaced innerHTML, so the <media-gallery> element
    // itself is the same instance but its children are new nodes.
    function rebindGallery(galleryEl, productInfoEl) {
      try {
        var viewer = galleryEl.querySelector('[id^="GalleryViewer"]');
        var thumbnails = galleryEl.querySelector('[id^="GalleryThumbnails"]');
        if (!viewer) return;

        // Re-point the element's cached child references if it exposes them.
        if (galleryEl.elements) {
          galleryEl.elements.viewer = viewer;
          galleryEl.elements.thumbnails = thumbnails;
          galleryEl.elements.liveRegion = galleryEl.querySelector('[id^="GalleryStatus"]');
        }

        // Rebind thumbnail click -> setActiveMedia (mirrors media-gallery.js).
        if (thumbnails && typeof galleryEl.setActiveMedia === 'function') {
          thumbnails.querySelectorAll('[data-target]').forEach(function (mediaToSwitch) {
            var btn = mediaToSwitch.querySelector('button');
            if (!btn) return;
            btn.addEventListener('click', function () {
              galleryEl.setActiveMedia(mediaToSwitch.dataset.target, false);
            });
          });
        }
      } catch (e) {
        console.warn('[Ahimsa] rebindGallery issue:', e);
      }
    }

    ProductInfo.prototype.__ahimsaGalleryPatched = true;
    return true;
  }

  // customElements.define for product-info may run after this file. Retry
  // until the class is registered, then patch once.
  if (!patch()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (patch() || tries > 100) clearInterval(iv);
    }, 50);
    // Also try once more after full load as a backstop.
    window.addEventListener('load', patch);
  }
})();